import { ProjectsSection } from '@/features/projects/project-section';

export const ProjectsPage = () => {
  return (
    <section className="flex flex-col gap-4">
      <ProjectsSection />
    </section>
  );
};
